import React from 'react';

import {pure} from 'recompose';
import {Flex} from 'reflexbox';


import Messages from './Messsages.js';
import Input from './Input.js';

import './Chat.css';

const Chat = (props) => (
  <Flex className='chat' align={'center'} justify={"flex-start"} style={{overflow: 'hidden'}} flexColumn={true}>
    <Messages
      messages={props.messages}
    />
    <Input
      sound={props.sound}
      playing={props.playing}
      updateMessages={props.updateMessages}
      deleteMessage={props.deleteMessage}
      uuid={props.uuid}
    />
  </Flex>
);

export default pure(Chat);



// WEBPACK FOOTER //
// ./src/components/Chat.js